import AdminActionTypes from './admin.types'
import { API } from '../../API'
import { notify } from 'react-notify-toast'

const INITIAL_STATE = {
  teacher: null,
  college_details: null,
  all_users: [],
  all_custs: [],
}

const adminReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AdminActionTypes.SET_TEACHER:
      return {
        ...state,
        teacher: action.payload,
      }

    case AdminActionTypes.SET_ALL_USERS:
      return {
        ...state,
        all_users: action.payload,
      }

    case AdminActionTypes.UPDATE_SEARCH_STATUS:
      const { user_id, is_searchable } = action.payload
      return {
        ...state,
        all_users: updateSearchStatus(state.all_users, user_id, is_searchable),
      }

    case AdminActionTypes.UPDATE_TEACHER_LEVEL:
      return {
        ...state,
        all_users: updateTeacherLevel(state.all_users, action.payload.user_id, action.payload.level),
      }

    case AdminActionTypes.UPDATE_CURRENT_COLLEGE_DETAILS:
      return {
        ...state,
        college_details: action.payload,
      }

    case AdminActionTypes.SET_ALL_CUSTOMERS:
      return {
        ...state,
        all_custs: action.payload,
      }

    default:
      return state
  }
}
export default adminReducer

//----------------------------------------------------------
//All the utils functions
//----------------------------------------------------------

const updateSearchStatus = (all_users, user_id, is_searchable) => {
  // functionality here
  const newAllUsers = all_users.map((user) => {
    if (user._id === user_id) {
      user.is_searchable = is_searchable
    }
    return user
  })

  API.updateSearchStatus(user_id, is_searchable)
    .then(res => {
      // console.log(res)
      notify.show("Search status updated")
    })
    .catch((err) => {
      console.log(err)
      notify.show('Error updating search status')
    })

  return newAllUsers
}

const updateTeacherLevel = (all_users, user_id, level) => {
  const newAllUsers = all_users.map((user) => {
    if (user._id === user_id) {
      user.level = level
    }
    return user
  })

  API.updateTeacherLevel(user_id, level)
    .then(res => {
      // console.log(res)
      notify.show("Teacher level updated")
    })
    .catch((err) => {
      console.log(err)
      notify.show('Error updating search status')
    })

  return newAllUsers
}

// put the modified user into the backend
// const updateNewUserToBackEnd = (user, msg) => {
//   axios
//     .put(`${PORT}/updateUser`, {
//       user: user,
//     })
//     .then((res) => {
//       notify.show(msg);
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };
